import { AppId, DevelopEnvironment, Environment, XPlatform } from '@foxeet/domain';
import { VERSION } from './version';

export const environment: Environment = {
  app: AppId.IVFORCE,
  appName: 'Tasafy Valum',
  wikiURL: 'https://wiki-force.valumre.com/',
  wikiURLBancoEsp: 'https://wiki-tecnica.iv.solutions',
  platform: XPlatform.MOBILE,
  production: false,

  appVersion: VERSION,
  version: VERSION,
  envName: DevelopEnvironment.dev,
  defaultEndpoint: 'https://dev-2-api.iv.solutions',
  devEndpoint: 'https://dev-2-api.iv.solutions',
  frontendUrl: 'https://dev-2-force.valumre.com',
  qaEndpoint: 'https://qa-migration.iv.solutions',
  prodEndpoint: 'https://api.iv.solutions',

  mapbox: {
    accessToken: 'pk.eyJ1IjoiaW5zdGl0dXRvIiwiYSI6ImNrN2xwd3hxdDAyYTkzZXAzdXJvaDd5aTQifQ.ep-LJ8wr0Jm3_nWlWf7NUw',
  },
  msal: {
    clientId: 'aa651d87-ece6-4466-8ac4-832cdd20e6fd',
    scope: 'aa651d87-ece6-4466-8ac4-832cdd20e6fd/IvForceDev',
    authority: 'https://login.microsoftonline.com/89143471-9c4d-401a-b5e4-6b4bcfaeb634'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
